
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('talktoProducerController.vrun.component', () => import('./components/TalktoProducerController.vue'))
